import React from 'react'
import useBlogData from 'client/hooks/useBlogData'
import { usePage } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { ActivePopup } from '../components/popup/active-popup'
import PageUi from '../ui/PageUi'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'

function BlogPostLayoutPage({ children }: { children: React.ReactNode }) {
  useBlogData()
  const { globalFontFamily, globalFontStyle, globalFontWeight } =
    useCalculateTypography({})

  return (
    <PageUi
      fontFamily={globalFontFamily}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
      <ActivePopup />
    </PageUi>
  )
}

export default BlogPostLayoutPage
